import type { ImageCollection } from "common/types/imageCollection";
import type { Signal } from "domains/signals/types";
import type { Topic } from "entities/topics/types";

export enum KnowledgeStatus {
  NOT_STARTED = "Not Started",
  PROCESSING = "Processing",
  DONE = "Done",
  ERROR = "Error",
}

export type Knowledge = KnowledgeResponse & {
  isBookmarkPending?: boolean;
  isPending?: boolean;
  knowledgeType: KnowledgeType;
  requestError?: boolean;
};

export type KnowledgeResponse = {
  attachment?: Attachment | null;
  created_at?: string | null;
  embedded_media?: EmbeddedMedia | null;
  id: string;
  image?: string;
  images?: ImageCollection | null;
  interactive_link?: string | null;
  is_bookmarked?: boolean;
  is_pinned?: boolean | null;
  language?: string | null;
  link: string;
  publisher: string;
  signals?: Signal[];
  source: Source;
  status?: KnowledgeStatus | null;
  status_meta?: string | null;
  summary?: string;
  time: number;
  title: string;
  topics: Topic[];
  type: "article" | "video" | "audio";
};

type Attachment = { id: string; url: string; image_url?: string; type: "video" | "podcast" | "audio" | "pdf" };
type EmbeddedMedia = {
  url?: string;
  width?: number;
  height?: number;
  title?: string | null;
  html?: string | null;
};
export type Source = {
  id?: string | null;
  name: string;
  images?: ImageCollection | null;
  content_type?: ContentType | null;
};

export enum ContentType {
  publication = "Articles and Publication",
  video = "Videos",
  data = "Data Visualizations",
  case_study = "Case Study",
  podcast = "Podcasts",
}

export enum KnowledgeType {
  article = "article",
  publication = "publication",
  video = "video",
  data = "data",
}

export type KnowledgeState = { byId: Record<string, Knowledge> };
